/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Combo_No_ResultsInputs */

const en_combo_no_results = /** @type {(inputs: Combo_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matches`)
};

const de_combo_no_results = /** @type {(inputs: Combo_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Treffer`)
};

/**
* | output |
* | --- |
* | "No matches" |
*
* @param {Combo_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const combo_no_results = /** @type {((inputs?: Combo_No_ResultsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Combo_No_ResultsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_combo_no_results(inputs)
	return en_combo_no_results(inputs)
});